<template>
  <el-card v-show="visible">
    <div class="row">
      <div class="col-xl-4 col-sm-6 mb-xl-0 mb-4">
        <div class="card" v-loading="loading">
          <div class="card-body p-3">
            <h6 class="card-title">Serviços</h6>
            <div class="row">
              <div class="col-9">
                <div class="numbers">
                  <p class="text-sm mb-0 font-weight-bold">
                    <el-form label-position="top">
                      <el-form-item>
                        <el-radio v-for="record of tableData" v-model="form.service" :key="record.code"
                          :label="record.code">{{ record.name }}&nbsp;<span class="badge badge-primary badge-pill">{{
                            record.total }} </span></el-radio>
                      </el-form-item>
                      <el-form-item :label="$t('utilizar-servico')">
                        <ServicesList v-model="form.selected" v-bind:multiple="false" />
                      </el-form-item>
                    </el-form>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom clearfix">
            <el-button type="success" plain class="w-100" @click="apply()">{{
              $t("aplicar")
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import { AuditService } from "@/services/customers/audit.services";
import ServicesList from "@/xpost/views/register/services/ServicesList";

export default {
  name: "AuditPendenciesServices",
  props: ["type"],
  components: {
    ServicesList
  },
  data() {
    return {
      visible: false,
      loading: false,
      tableData: [],
      form: {
        service: '',
        selected: '',
      }
    }
  },
  methods: {
    show() {
      this.visible = true;
      this.fetchRecords();
    },
    hide() {
      this.visible = false;
    },
    apply() {
      const vm = this;
      if (!vm.form.selected || !vm.form.service) {
        return vm.$message({ type: "error", message: 'É preciso selecionar o serviço e o serviço utilizado!' });
      }
      const loading = vm.$loading(vm.$options.loading);
      AuditService.toservice(vm.form.selected, vm.form.service)
        .then((response) => {
          vm.$message({ type: "success", message: 'Serviço corrigido nas pendências de auditoria!' });
          vm.$emit('reload');
          vm.visible = false;
        })
        .catch((error) => {
          vm.$message({ type: "error", message: error });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      setTimeout(() => {
        AuditService.services(vm.type)
          .then((response) => {
            vm.tableData = response;
          })
          .catch((error) => {
            vm.$message({ type: "error", message: error });
          })
          .finally(() => vm.loading = false);

      }, 200);
    },
  },
};
</script>
<style scoped>
.list-group-item {
  padding-top: 15px !important;
}
</style>